var render, staticRenderFns
import script from "./index.vue?vue&type=script&lang=jsx&"
export * from "./index.vue?vue&type=script&lang=jsx&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports